module.exports = __webpack_public_path__ + "img/9K.05dd8cc4.png";